var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-breadcrumb"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.system.domain}},[_vm._v("Home")])]),_c('li',[_c('a',{attrs:{"href":_vm.routePath}},[_vm._v(_vm._s(_vm.routeName))])]),(_vm.addRoute.name!='')?_c('li',[_c('a',{attrs:{"href":_vm.addRoute.path}},[_vm._v(_vm._s(_vm.addRoute.name))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }